module.exports = "/static/assets/127373191db953ce5e27630fda2ca80c.png";